import { AvailableExtra } from '~/lib/types/basket-types';
import { Protection } from '~/lib/types/extra-types';

/**
 *  This is the scenario where they took protection on the quote page and now they've increased the parcel value
 * to more than the included protection amount.
 * In the case of the base protection, the maxProtection is based on the base protection, not service max.
 **/
export const IsSpecialQuotePageScenario = (
  isCheapestOption: boolean,
  extra: AvailableExtra,
  parcelValue: number,
  protectedAmount: number
): boolean => {
  return isCheapestOption && extra?.key === Protection.BASE && parcelValue > protectedAmount;
};

// This is the scenario where they have included/free protection and the 'No' option is shown.
export const QuoteIncludedCoverButParcelValueIsHigher = (
  isCheapestOption: boolean,
  option: AvailableExtra,
  parcelValue: number,
  includedFreeOrBaseProtectionAmount: number
): boolean => {
  return (
    isCheapestOption &&
    option?.key === Protection.NONE &&
    includedFreeOrBaseProtectionAmount > 0 &&
    parcelValue > includedFreeOrBaseProtectionAmount
  );
};
